var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 67.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}.cls-3{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon experience") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 41.48,
    cy: 64.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.78,
    cy: 64.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66.65,
    cy: 64.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 78.52,
    cy: 64.5,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.5,
    y: 1.5,
    width: 45,
    height: 45,
    rx: 11.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.5,5.61a9.3,9.3,0,0,1,9.3,9.3V32.09a9.3,9.3,0,0,1-9.3,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.2,9.46a7.3,7.3,0,0,1,7.3,7.3V30.24a7.3,7.3,0,0,1-7.3,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.5,5.61a9.3,9.3,0,0,0-9.3,9.3V32.09a9.3,9.3,0,0,0,9.3,9.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.8,9.46a7.3,7.3,0,0,0-7.3,7.3V30.24a7.3,7.3,0,0,0,7.3,7.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExperience);
export default __webpack_public_path__ + "static/media/iconExperience.95082f0a98ffb248b0449312359bc4d6.svg";
export { ForwardRef as ReactComponent };